/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['ups'] }] */
import React from 'react';
import PropTypes from 'prop-types';

import ManCarryingPackage from 'images/zappos/man-carrying-package.svg';
import PrintingReturnLabel from 'images/zappos/printing-return-label.svg';
import StackedBoxes from 'images/zappos/stacked-boxes.svg';
import UPSBanner from 'components/account/UPSBanner';
import css from 'styles/components/account/returns/returnsAndExchanges.scss';

const ReturnsAndExchanges = (_, { marketplace }) => {
  const { returns: { showReturnsAndExchanges } } = marketplace;
  if (!showReturnsAndExchanges) {
    return null;
  }

  return (
    <div className={css.returnsAndExchanges}>
      <h2>How to Return Your Item(s)</h2>
      <UPSBanner />
      <div className={css.boxes}>
        <div>
          <h3>Print Your Label</h3>
          <div className={css.illustration}>
            <img src={PrintingReturnLabel} alt=""/>
          </div>
          <div>Ship your return back to us using any cardboard box or a Zappos box (remove pre-existing labels and markings).</div>
        </div>
        <div>
          <h3>Pack Your Box</h3>
          <div className={css.illustration}>
            <img src={ManCarryingPackage} alt=""/>
          </div>
          <div>Place item(s) you're returning back in their original packaging and then put in the cardboard shipping box from step 1.</div>
        </div>
        <div>
          <h3>Send it Back Through UPS</h3>
          <div className={css.illustration}>
            <img src={StackedBoxes} alt=""/>
          </div>
          <div>
            Seal box, attach return label, and take to an authorized UPS location. <a href="/self-service-return-instructions">Learn more about the UPS return process</a>.
          </div>
        </div>
      </div>
    </div>
  );
};

ReturnsAndExchanges.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default ReturnsAndExchanges;
